import FormModalContentContainer from "components/layout/FormModalContentContainer";
import PraxFormGrid from "components/layout/PraxFormGrid";
import { ExtendedBaseEntryDto } from "components/segments/entires/EntriesContext";
import React, { Component } from "react";
import { MessageSourceProps, withMessages } from "react-message-source";
import { Button, Grid, Modal, Table } from "semantic-ui-react";
import { BaseEntryDto } from "ts-types/api.types";

interface Props extends MessageSourceProps {
  modalOpen: boolean,
  onCloseModal: () => void,
  // the reference procedure that can only be entered through one of its master procedures
  referenceProcedure?: ExtendedBaseEntryDto,
  // tells whether the given master procedure is already part of the consultation
  isMasterPresent: (master: BaseEntryDto) => boolean,
  onSelectMaster: (master: BaseEntryDto) => void
}

/**
 * Shown when a TARMED reference procedure with more than one master procedure is added/edited:
 * the user has to pick the master procedure through which the reference procedure will be entered.
 */
class ReferenceProcedureMastersModal extends Component<Props> {

  render(): React.ReactNode {

    const {modalOpen, onCloseModal, getMessage} = this.props;

    return (
        <Modal
            open={modalOpen}
            onClose={onCloseModal}
            closeOnDimmerClick={false}
        >
          <Modal.Header>
            {getMessage("referenceProcedure.header")}
          </Modal.Header>
          <FormModalContentContainer>
            {this.renderModalContent()}
          </FormModalContentContainer>
          <Modal.Actions>
            <Button compact type="button" onClick={onCloseModal}>{getMessage("button.cancel")}</Button>
          </Modal.Actions>
        </Modal>
    );
  }

  renderModalContent = (): React.ReactNode => {

    const {referenceProcedure, getMessageWithNamedParams} = this.props;

    if (!referenceProcedure) {
      return null;
    }

    return (
        <PraxFormGrid>
          <Grid.Row>
            <Grid.Column>
              {getMessageWithNamedParams("referenceProcedure.enterThroughMaster", {
                procedureCode: referenceProcedure.code,
                procedureDescription: referenceProcedure.description
              })}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            {this.renderMastersTable(referenceProcedure.masters || [])}
          </Grid.Row>
        </PraxFormGrid>
    );
  };

  renderMastersTable = (masters: Array<BaseEntryDto>): React.ReactNode => {

    const {getMessage, isMasterPresent, onSelectMaster} = this.props;

    const rows = masters.map((master, index) => {

      const present = isMasterPresent(master);

      return (
          <Table.Row key={index} onClick={() => onSelectMaster(master)} style={{cursor: "pointer"}}>
            <Table.Cell>{master.code}</Table.Cell>
            <Table.Cell>{master.description}</Table.Cell>
            <Table.Cell>
              {present
                  ? getMessage("referenceProcedure.masterPresent")
                  : getMessage("referenceProcedure.masterNotPresent")}
            </Table.Cell>
          </Table.Row>
      );
    });

    return (
        <Table basic="very" celled selectable compact style={{marginLeft: "10px", marginRight: "10px"}}>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>{getMessage("code")}</Table.HeaderCell>
              <Table.HeaderCell>{getMessage("description")}</Table.HeaderCell>
              <Table.HeaderCell>{getMessage("referenceProcedure.masterStatus")}</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {rows}
          </Table.Body>
        </Table>
    );
  };
}

export default withMessages(ReferenceProcedureMastersModal);
